import BezierEasing from 'bezier-easing';

import gsap from 'gsap';

import Scrollbar from 'smooth-scrollbar';

import Barba from 'barba.js';

import Component from '../base/component';
import { qs, toggleClass } from '../base/dom-utils';
import Common from '../base/common';

const articleIn = BezierEasing(0.3, 0.43, 0, 0.99);

class Single extends Component {

    constructor(el, opts) {
        super(el, opts);

        this.$els.body = qs(this.options.body, this.el);
        this.$els.header = qs(this.options.header, this.el);
        this.$els.main = qs(this.options.main, this.el);
        this.$els.closePost = qs(this.options.closePost, this.el);

        toggleClass(document.body, 'is-article-open', true);

        this.closePost = this.closePost.bind(this);

        if (Common.mq('l-tablet')) {

            this._scrollbar = Scrollbar.init(qs('[data-scrollbar]'));

        }

        gsap.set(this.$els.body, {
            opacity: 0,
            x: 40
        });

        gsap.set(this.$els.header, {
            opacity: 0,
            x: 40
        });

        gsap.set(this.$els.closePost, {
            opacity: 0
        });

        gsap.set(this.$els.main, {
            opacity: 0,
            x: 40
        });

    }

    beforeInit() {
        this.delegate('click', this.options.closePost, this.closePost);
    }

    closePost(evt) {
        evt.stopPropagation();
        evt.preventDefault();

        const element = evt.target;
        const prevStatus = Barba.HistoryManager.prevStatus();

        let url = '/';

        if (prevStatus) {
            url = prevStatus.url;
        }

        Barba.Dispatcher.trigger('linkClicked', element, evt);
        Barba.Pjax.goTo(url);
    }

    animationIn() {

        const enterTl = new TimelineMax();

        enterTl.to(this.$els.header, 1.5, {
            opacity: 1,
            x: 0,
            ease: new Ease(articleIn)
        })

        .to(this.$els.main, 1.5, {
            opacity: 1,
            x: 0,
            ease: new Ease(articleIn)
        }, '-=1.5')

        .to(this.$els.body, 1.5, {
            opacity: 1,
            x: 0,
            ease: new Ease(articleIn)
        }, '-=1.35')

        .to(this.$els.closePost, 1, {
            opacity: 1,
            ease: new Ease(articleIn)
        }, '-=1');
    }

    getDefaultOptions() {
        return {
            article: '.c-article',
            main: '.c-article__main',
            body: '.c-article__body',
            header: '.c-article__header',
            closePost: '#close-post'
        }
    }

    destroy() {

        if (Common.mq('l-tablet')) {
            this._scrollbar.destroy();
        }

        toggleClass(document.body, 'is-article-open', false);

        return super.destroy();
    }
}

export default Single;


/** WEBPACK FOOTER **
 ** ./containers/Single.js
 **/